import { Component, ElementRef, NgZone, AfterViewInit, ViewChild, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { RecaptchaLoaderService } from './recaptcha-loader.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-recaptcha',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<div #captcha></div>'
})
export class RecaptchaComponent implements AfterViewInit {
  @ViewChild('captcha', { static: true }) el!: ElementRef<HTMLDivElement>;

  @Output() resolved = new EventEmitter<string>();
  @Output() expired = new EventEmitter<void>();

  private widgetId?: number;

  constructor(
    private recaptchaLoaderService: RecaptchaLoaderService,
    private zone: NgZone
  ) { }

  async ngAfterViewInit() {
    await this.recaptchaLoaderService.load();

    this.zone.runOutsideAngular(() => {
      window.grecaptcha.ready(() => {
        this.widgetId = window.grecaptcha.render(this.el.nativeElement, {
          sitekey: environment.recaptchaSiteKey,
          callback: (token: string) => this.zone.run(() => this.resolved.emit(token)),
          'expired-callback': () => this.zone.run(() => this.expired.emit())
        });
      });
    });
  }
}
